// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.active{
    color: #28A079 !important;
}
.loader {
    display: flex;
    align-items: center;
    justify-content: center;
        --d: 22px;
        width: 4px;
        height: 4px;
        border-radius: 50%;
        color: #25b09b;
        box-shadow:
        calc(1 *var(--d)) calc(0 *var(--d)) 0 0,
            calc(0.707 *var(--d)) calc(0.707 *var(--d)) 0 1px,
                calc(0 *var(--d)) calc(1 *var(--d)) 0 2px,
                    calc(-0.707 *var(--d)) calc(0.707 *var(--d)) 0 3px,
                        calc(-1 *var(--d)) calc(0 *var(--d)) 0 4px,
                            calc(-0.707 *var(--d)) calc(-0.707 *var(--d)) 0 5px,
                                calc(0 *var(--d)) calc(-1 *var(--d)) 0 6px;
        animation: l27 1s infinite steps(8);
    }
    @keyframes l27 {
        100% 
        { transform: rotate(1turn) }
    }

.custom-checkbox {
    appearance: none; /* Remove default styling */
    width: 16px;
    height: 16px;
    border: 2px solid #ccc;
    border-radius: 4px;
    cursor: pointer;
    position: relative;
}

.custom-checkbox:checked {
    background-color: #3CC8A1; /* Green tick background */
    border-color: #3CC8A1; /* Optional: Change border color too */
}

.custom-checkbox:checked::after {
    content: ''; /* Unicode for the check mark */
    color: white;
    font-size: 12px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;QACnB,SAAS;QACT,UAAU;QACV,WAAW;QACX,kBAAkB;QAClB,cAAc;QACd;;;;;;;0EAOkE;QAClE,mCAAmC;IACvC;IACA;QACI;UACE,yBAAyB;IAC/B;;AAEJ;IACI,gBAAgB,EAAE,2BAA2B;IAC7C,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB,EAAE,0BAA0B;IACrD,qBAAqB,EAAE,sCAAsC;AACjE;;AAEA;IACI,WAAW,EAAE,+BAA+B;IAC5C,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC","sourcesContent":[".active{\n    color: #28A079 !important;\n}\n.loader {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n        --d: 22px;\n        width: 4px;\n        height: 4px;\n        border-radius: 50%;\n        color: #25b09b;\n        box-shadow:\n        calc(1 *var(--d)) calc(0 *var(--d)) 0 0,\n            calc(0.707 *var(--d)) calc(0.707 *var(--d)) 0 1px,\n                calc(0 *var(--d)) calc(1 *var(--d)) 0 2px,\n                    calc(-0.707 *var(--d)) calc(0.707 *var(--d)) 0 3px,\n                        calc(-1 *var(--d)) calc(0 *var(--d)) 0 4px,\n                            calc(-0.707 *var(--d)) calc(-0.707 *var(--d)) 0 5px,\n                                calc(0 *var(--d)) calc(-1 *var(--d)) 0 6px;\n        animation: l27 1s infinite steps(8);\n    }\n    @keyframes l27 {\n        100% \n        { transform: rotate(1turn) }\n    }\n\n.custom-checkbox {\n    appearance: none; /* Remove default styling */\n    width: 16px;\n    height: 16px;\n    border: 2px solid #ccc;\n    border-radius: 4px;\n    cursor: pointer;\n    position: relative;\n}\n\n.custom-checkbox:checked {\n    background-color: #3CC8A1; /* Green tick background */\n    border-color: #3CC8A1; /* Optional: Change border color too */\n}\n\n.custom-checkbox:checked::after {\n    content: ''; /* Unicode for the check mark */\n    color: white;\n    font-size: 12px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
